import { useEffect, useState } from "react";
import "./ForthcomingEvents.css";

export default function ForthcomingEvent() {
  const images = [
    "/Images/price1.jpg",
    "/Images/price2.jpg",
    "/Images/price3.jpg",
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="forthcoming59-section">
      <div className="forthcoming59-header">
        <img src="/Images/ballimg.png" className="forthcoming59-ball-icon" />
        <p className="forthcoming59-tagline">Big Stage. Bigger Rewards.</p>
        <h2 className="mainHeadingLK">ATPL Prize Money Tournament</h2>
      </div>

      <div className="forthcoming59-row">
        <div className="forthcoming59-image-col">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              className={`slide ${index === current ? "active" : ""}`}
              alt="price slide"
            />
          ))}
        </div>

        <div className="forthcoming59-details-col">
          <h3>Rewarding Excellence</h3>
          <div className="forthcoming59-line"></div>
          <p>
            The ATPL Women’s T-20 Championship rewards outstanding performance with
            prestigious cash prizes. Champions take home ₹3,00,000, while the runners-up
            earn ₹2,00,000 and the third-place team secures ₹1,00,000. A celebration of
            talent, dedication, and the spirit of women's cricket in India.
          </p>

        </div>

        <div className="forthcoming59-price-col">

          <h4 className="forthcoming59-price-title">Prizes</h4>

          <div className="forthcoming59-prize-item">
            <span>1st Prize</span>
            <strong>₹3,00,000</strong>
          </div>

          <div className="forthcoming59-prize-item">
            <span>2nd Prize</span>
            <strong>₹2,00,000</strong>
          </div>

          <div className="forthcoming59-prize-item">
            <span>3rd Prize</span>
            <strong>₹1,00,000</strong>
          </div>

          <button className="forthcoming59-view-btn">View More</button>
        </div>

      </div>
    </section>
  );
}
